import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=3f5480e3&scoped=true&"
import script from "./Rule.vue?vue&type=script&lang=js&"
export * from "./Rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5480e3",
  null
  
)

export default component.exports